module.exports = __webpack_public_path__ + "flyer_background_champagne_049-367e2ab449a64fa74d4ae50914fab994.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Layouts/Backgrounds/flyer_background_champagne_049.jpg
// module id = 1618
// module chunks = 1